module.exports = __webpack_public_path__ + "static/chrome-332df9a3c112ad4f9957b2955ccd6e8a.png";